import { getToken } from './api'

// Where a successful login sends the user. Leave empty to stay on this app instead.
export const DEMO_REDIRECT_URL = 'https://demo.oddspulse.org'

/**
 * The apex is the front door and nothing else: it shows the login form, and anyone who already holds a
 * token is sent straight on to the demo subdomain. The app itself only ever renders on that subdomain.
 */
const LOGIN_ONLY_HOSTS = ['oddspulse.org', 'www.oddspulse.org']

export const isLoginOnlyHost = () => LOGIN_ONLY_HOSTS.includes(window.location.hostname)

/**
 * Holding a token is not the same as the server accepting it — that is settled by the first call, which
 * clears it and reloads on a 401. This only decides whether to paint the form or the app first.
 */
export const isAuthenticated = () => Boolean(getToken())
